import React from 'react'
import { useParams } from 'react-router-dom'
import { Container, makeStyles } from '@material-ui/core'
import ProfileCard from './ProfileCard'
import { useGetProfiles } from '../../MyBookings/hooks/useGetProfiles'
import { Error, Loader } from '../../../components'
import { extractResponse } from '../../../utils'
import { NoCandidates } from './NoCandidates'

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        margin: 'auto',
        display: 'block',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            width: '80%',
        },
    },
}))

function Profiles() {
    const classes = useStyles()
    const { bookingId, status } = useParams()
    const { isLoading, data, error } = useGetProfiles(bookingId, status)

    if (isLoading) {
        return <Loader />
    }

    if (error) {
        return <Error error={error} />
    }

    const res = extractResponse(data)

    if (res?.error) {
        return <Error error={error} />
    }

    if (res?.data?.length === 0) {
        return <NoCandidates />
    }

    const profiles = res.data.workers

    console.log(profiles)
    console.log(profiles[1])

    return (
        <Container className={classes.container}>
            {profiles.map((profile) => (
                <ProfileCard key={profile.id} profile={profile} />
            ))}
        </Container>
    )
}

export default Profiles
